/**
* @Author: Roxy Chen
* @Date:   2016-08-17T18:10:52+08:00
* @Last modified by:   Roxy Chen
* @Last modified time: 2016-08-22T19:43:21+08:00
* @License: Copyright (c) by Giftpack Inc. All Rights Reserved.
*/

// import CountUp from '../../tool/Customize_Plugin/react-countup';
import CountUp from "react-countup";
import { Waypoint } from "react-waypoint";

// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/global";


import { Navigator , MobileNav } from "./nav";
import AnimateEffect from "../../tool/animateEffect";
import Popup from "./Popup.js";

import apple from "../../../images/icon/apple-download.png";
import android from "../../../images/icon//google-download.png";

import feature_1 from "../../../images/intro/maidwhite.png";
import feature_2 from "../../../images/intro/2.jpg";
import feature_3 from "../../../images/intro/irharuka.png";
import feature_4 from "../../../images/intro/4.jpg";

import { IndexFooter } from "./indexFooter.js";

import { StringHelper, _ } from "../../strings";
import  LanguageBar from "../LanguageBar";


export default class Index extends Component {
  constructor(props) {
    console.log("Index constructor")
    super(props);
    this.state = {
      serviceWaypoint: false,
      landingWaypoint: false,
      numberTalksWayPoint: false,
      navFix: true,
      driver_number: 0,
      support_counter: 0,
      subscriberEmail: "",
      popupVisibility: null
    };
  }
  componentDidMount(){
    console.log("Index componentDidMount");
    this.loadCounter();
    
    // Temporary fix: trigger waypoints after delays
    setTimeout(() => {
      console.log('Triggering landingWaypoint');
      this.setState({landingWaypoint: true});
    }, 500);
    
    setTimeout(() => {
      console.log('Triggering serviceWaypoint');
      this.setState({serviceWaypoint: true});
    }, 1000);
    
    setTimeout(() => {
      console.log('Triggering numberTalksWayPoint');
      this.setState({numberTalksWayPoint: true});
    }, 1500);
  }

  onLanguageChange(newLanguage) {
    console.log("newLanguage: ", newLanguage);
    this.forceUpdate();
  }

  loadCounter() {
    //API Counter.
    var counterApiUrl = "https://www.tih.tw/2/server-static";

    var counterRequest = new XMLHttpRequest();
    counterRequest.responseType = "json";
    var $$t = this;
    counterRequest.onload = function(){
      var counterResponse = counterRequest.response;
      console.log("counterRequest onload: " + JSON.stringify(counterResponse))
      $$t.setState({
        driver_number: counterResponse.driver_number,
        support_counter: counterResponse.counter
      });
    }
    /*xmlhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            var myObj = JSON.parse(this.responseText);
            driver_number = myObj.driver_number;
            support_counter = myObj.counter;
        }
    };*/
    //xmlhttp.open("GET", counterApiUrl, true);
    //xmlhttp.send();
    counterRequest.open("GET", counterApiUrl, true);
    counterRequest.send();
    //End API Counter.

  }

  sendSubscribeEmail(evt) {
    if (this.state.subscriberEmail == _("text_reveived_subscribe_mail_request")) {
      return
    }
    var counterApiUrl = "https://www.tih.tw/2/email-subscribe";


    var counterRequest = new XMLHttpRequest();
    counterRequest.responseType = "json";
    var $$t = this;
    counterRequest.onload = function(){
      $$t.setState({subscriberEmail: _("text_reveived_subscribe_mail_request")})
    }
    counterRequest.open("POST", counterApiUrl, true);
    counterRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    counterRequest.send("email=" + encodeURIComponent(this.state.subscriberEmail));
  }

  updateEmailInputValue(evt) {
    this.setState({subscriberEmail: evt.target.value})
  }

  clickMeetMaidWhite() {
    console.log("meet maid white did clicked");

  }


  render() {
    const {
      serviceWaypoint,
      landingWaypoint,
      numberTalksWayPoint,
      navFix
    } = this.state;
    return (
      <div className="main-container">
        <Navigator onTop={navFix}/>
        <MobileNav />
        <section className="section-1 vertical-flex-item">
        <Waypoint onEnter={()=>!landingWaypoint&&this.setState({landingWaypoint: true})} />
          <div className="landing-container">
            <AnimateEffect trigger={landingWaypoint} className={"brand"} effect={"fadeInUp"} delay={2000} >{_("page_company_name")}</AnimateEffect>
            <AnimateEffect trigger={landingWaypoint} className={"title"} effect={"fadeIn"} delay={1000} >{_("page_title")}</AnimateEffect>
            <AnimateEffect trigger={landingWaypoint} className={"sub-title"} effect={"fadeInDown"} delay={1500} >{_("page_subtitle")}</AnimateEffect>
            <div className="download-group tempHide">
              <AnimateEffect trigger={landingWaypoint} className={"download"} effect={"fadeInDown"} delay={2500} >{_("download_on")}</AnimateEffect>
              <div className="link">
                <AnimateEffect trigger={landingWaypoint} effect={"fadeInUp"} delay={3000} >
                  <a href="#"><img src={apple} width="172"/></a>
                </AnimateEffect>
                <AnimateEffect trigger={landingWaypoint} effect={"fadeInUp"} delay={3100} >
                  <a href="#"><img src={android} width="172"/></a>
                </AnimateEffect>
              </div>
            </div>
          </div>
        <Waypoint onEnter={()=>!navFix&&this.setState({navFix: true})} />
        </section>
        <section className="section-2 vertical-flex-item" id="serviceSection">
          <Waypoint onEnter={()=>!serviceWaypoint&&this.setState({serviceWaypoint: true})} />
          <div className="service-container">
            <div className="title-group">
              <div className="title">{_("our_service_title")}</div>
              <div className="sub-title">{_("our_service_subtitle")}</div>
            </div>
            <div className="service-features">
              <AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={800} >
                <div className="feature-image"><img src={feature_1}/><div className="overlay"/></div>
                <div className="feature-content">
                  <div className="feature-content-title">{_("MaidWhite")}</div>
                  <div className="feature-content-text">
                    <p>{_("maid_white_desc")}</p>
                  </div>
                </div>
                <div className="make-it-show-popup" onClick={()=>{
                  ga("send", "event", "meet_it", "click", "maid_white_block", 200);
                  this.setState({popupVisibility: true});
                }} >
                  <div className="meet-it-text">{_("meet_it")}</div>
                </div>
              </AnimateEffect>
              <AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={600} >
                <div className="feature-image"><img src={feature_2}/><div className="overlay"/></div>
                <div className="feature-content">
                  <div className="feature-content-title">{_("app_dev")}</div>
                  <div className="feature-content-text">
                    <p>{_("app_dev_desc")}</p>
                  </div>
                </div>
              </AnimateEffect>

              <AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={700} >
                <div className="feature-image"><img src={feature_3}/><div className="overlay"/></div>
                <div className="feature-content">
                  <div className="feature-content-title">{_("irharuka_title")}</div>
                  <div className="feature-content-text">
                    <p>{_("irharuka_desc")}</p>
                  </div>
                </div>
                <div className="make-it-show-popup" onClick={()=>{}} >
                  <div className="meet-it-text">
                    <a href="https://www.tih.tw/shop/IRHaruka" target="_blank">
                    {_("irharuka_link_text")}
                    </a>
                  </div>
                </div>
              </AnimateEffect>

              <AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={900} >
                <div className="feature-image"><img src={feature_4}/><div className="overlay"/></div>
                <div className="feature-content">
                  <div className="feature-content-title">{_("ryoku_simulator")}</div>
                  <div className="feature-content-text">
                    <p>{_("ryoku_simulator_desc")}</p>
                  </div>
                </div>
                <div className="make-it-show-popup" onClick={()=>{}} >
                  <div className="meet-it-text">
                    <a href="https://www.tih.tw/simulator/air-conditioner/" target="_blank">
                    {_("meet_it")}
                    </a>
                  </div>
                </div>
              </AnimateEffect>

            </div>
            <Waypoint onEnter={()=>navFix&&this.setState({navFix: false})} />
          </div>
        </section>
        <section className="section-3 vertical-flex-item">
          <div className="counts-container">
            <div className="title-group">
              <div className="title">{_("about_numbers_title")}</div>
              <div className="sub-title">{_("about_numbers_subtitle")}</div>
            </div>
            <Waypoint onEnter={()=>!numberTalksWayPoint&&this.setState({numberTalksWayPoint: true})} />
            <div className="services-use-count">
              <div className="count-display">
                <div className="total-counts"><CountUp trigger={numberTalksWayPoint.toString()} start={0} end={17} /></div>
                <div className="service-intro">{_("number_of_supported_brands")}</div>
              </div>
              <div className="count-display">
                <div className="total-counts"><CountUp trigger={numberTalksWayPoint.toString()} start={0} end={this.state.support_counter}/></div>
                <div className="service-intro">{_("number_of_requests")}</div>
              </div>
              <div className="count-display">
                <div className="total-counts"><CountUp trigger={numberTalksWayPoint.toString()} start={0} end={this.state.driver_number}/></div>
                <div className="service-intro">{_("number_of_supported_devices")}</div>
              </div>
            </div>
          </div>

        </section>
        <section className="section-4 vertical-flex-item">
          <div className="subscribe-container">
            <div  className="subscribe-symbol">
              <input
                type="email" placeholder={_("subscribe_by_email")}
                value={this.state.subscriberEmail}
                onChange={(evt) => this.updateEmailInputValue(evt)}/>
              <span className="subscribe-symbol email" onClick={(evt) => this.sendSubscribeEmail()}></span>
            </div>
            <div className="horizon"/>

            <div className="subscribe-symbol facebook vertical-flex-item">
            <div><a target="_blank" className="link-white" href="https://fb.me/TIH.tw">{_("follow_us_on_facebook")}</a></div></div>
          </div>
        </section>
        <IndexFooter />
        <Popup
            visibility={this.state.popupVisibility}
            onClose={() => this.setState({popupVisibility: false})}
          />
        <LanguageBar onChange={(lang) => this.onLanguageChange(lang)}/>
      </div>
    );

  }
}





// export default connect((state , ownProps ) => ( state ))( Index );
